import {
  endpoints,
  SmartInviteMyTickets,
  SmartInviteTicketReturns,
} from '@seaters/constants';
import { api } from '../axios-instance';

const selectionsBase = endpoints.smartInviteSelections;

// Refused once the event has started; the tickets stay valid until the return is decided.
export const requestSmartInviteTicketReturn = (
  waitingListId: string,
  note?: string
): Promise<SmartInviteMyTickets> =>
  api.post(`${selectionsBase}/my-tickets/${waitingListId}/return-request`, {
    note: note || undefined,
  });

export const withdrawSmartInviteTicketReturn = (
  waitingListId: string
): Promise<SmartInviteMyTickets> =>
  api.delete(`${selectionsBase}/my-tickets/${waitingListId}/return-request`);

export const fetchSmartInviteTicketReturns = (
  waitingListId: string
): Promise<SmartInviteTicketReturns> =>
  api.get(`${selectionsBase}/experiences/${waitingListId}/returns`);

export const approveSmartInviteTicketReturn = (
  selectionId: string
): Promise<SmartInviteTicketReturns> =>
  api.post(`${selectionsBase}/returns/${selectionId}/approve`);

export const rejectSmartInviteTicketReturn = (
  selectionId: string,
  reason?: string
): Promise<SmartInviteTicketReturns> =>
  api.post(`${selectionsBase}/returns/${selectionId}/reject`, {
    reason: reason || undefined,
  });
